export default "__VITE_ASSET__DppmuDgb__"